import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';

@Component({
  selector: 'app-cookie',
  templateUrl: './cookie.component.html'
})
export class CookieComponent implements OnInit {

  cookieKyeName = "ASC_Cookie_Accepted";
  cookieText = "";
  contentAvailable = false;

  constructor(private graphQlService: GraphqlService, private commonDataService: CommonDataService) { }

  ngOnInit(): void {

    forkJoin([
      this.graphQlService.getGlobalLabels(),
      this.graphQlService.getCookie(),
    ]).subscribe(([cookieLabels, cookie]) => {
      this.getCookieLabels(cookieLabels);
      if (cookie != null) {
        this.commonDataService.acceptCookie.next(cookie);
      }
    }, err => { console.log(err); this.commonDataService.showLoader.next(false); });
  }

  getCookieLabels(cookieLabels) {
    this.commonDataService.showLoader.next(true);
    if (cookieLabels != null) {
      let labels = cookieLabels.content.data.labels;
      this.cookieText = labels.filter(x => x.key == "cookie_privacy_policy_text").map(a => a.value);
      this.contentAvailable = true;
      this.commonDataService.showLoader.next(false);
    }
  }

  cookieAcceptClick() {
    this.graphQlService.setCookie(true).subscribe(data => {
      if (data != null && data.success) {
        this.commonDataService.acceptCookie.next(true);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

}
